import * as Yup from "yup";

export const createAccountValidationSchema = Yup.object({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords do not match")
    .required("Please confirm your password"),
  year: Yup.string(),
  gender: Yup.string(),
  race: Yup.string(),
  accepted: Yup.boolean().oneOf(
    [true],
    "You must accept the Terms and Conditions",
  ),
});
